import { Box, Button, Dialog, Text, TextField } from '@radix-ui/themes';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { CreateBankRequest } from '../../model/Bank.model';
import BankService from '../../service/bank-service/Bank.service';

interface CreateBankModalProps {
  onSuccess: () => void;
}

const CreateBankModal: React.FC<CreateBankModalProps> = ({ onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState<CreateBankRequest>({
    name: '',
    address: '',
    phoneNumber: '',
    email: '',
    website: '',
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await BankService.createBank(formData);
      toast.success('Tạo ngân hàng thành công!');
      onSuccess();
      setOpen(false);
      setFormData({
        name: '',
        address: '',
        phoneNumber: '',
        email: '',
        website: '',
      });
    } catch (error: any) {
      console.error('Error creating bank:', error);
      toast.error(error.message || 'Có lỗi xảy ra khi tạo ngân hàng!');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger>
        <Button color="indigo" variant="soft" className="cursor-pointer">
          Tạo ngân hàng mới
        </Button>
      </Dialog.Trigger>

      <Dialog.Content style={{ maxWidth: 700 }}>
        <Dialog.Title>Tạo ngân hàng</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          Điền thông tin ngân hàng
        </Dialog.Description>

        <form onSubmit={handleSubmit}>
          <Box className="space-y-4">
            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Tên ngân hàng <span className="text-red-500">*</span>
              </Text>
              <TextField.Root
                name="name"
                placeholder="Nhập tên ngân hàng"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Địa chỉ
              </Text>
              <TextField.Root
                name="address"
                placeholder="Nhập địa chỉ"
                value={formData.address}
                onChange={handleChange}
              />
            </div>

            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Số điện thoại
              </Text>
              <TextField.Root
                name="phoneNumber"
                placeholder="Nhập số điện thoại"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </div>

            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Email
              </Text>
              <TextField.Root
                type="email"
                name="email"
                placeholder="Nhập email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <Text as="label" size="2" mb="1" weight="bold">
                Website
              </Text>
              <TextField.Root
                name="website"
                placeholder="Nhập website"
                value={formData.website}
                onChange={handleChange}
              />
            </div>
          </Box>

          <div className="flex justify-end space-x-2 pt-4">
            <Dialog.Close>
              <Button variant="soft" color="gray" className="cursor-pointer">
                Hủy
              </Button>
            </Dialog.Close>
            <Button
              color="indigo"
              variant="soft"
              type="submit"
              className="cursor-pointer"
            >
              Hoàn thành
            </Button>
          </div>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default CreateBankModal;
